import styled from 'styled-components';
import { Tooltip } from 'react-bootstrap';

export const StyledTooltip = styled(Tooltip)`
  position: absolute !important;
  .tooltip-arrow {
    display: none !important;
  }
  .tooltip-inner {
    background-color: ${({ theme }) => theme?.dark40} !important;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.06), 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    font-size: 11px;
    font-weight: 400;
    font-family: ${({ theme }) => theme?.fontFamily} !important;
  }
`;
